export default "__VITE_ASSET__CAPde$ZD__"